module.exports = __webpack_public_path__ + "static/media/1417950283.48758dbf.ttf";